import { render, staticRenderFns } from "./BookingDetailTimeline.vue?vue&type=template&id=72dd17d8&"
import script from "./BookingDetailTimeline.vue?vue&type=script&lang=js&"
export * from "./BookingDetailTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports